export const state = {
    approvers: [],
  };
